import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

import { OrganisationRouter } from './organisation/_router'
import { PersonRouter } from './person/_router'
import { SignupRequestRouter } from './signup-request/_router'
import { UserInvitationRouter } from './user-invitation/_router'

const Index = lazy(() => import('./Index'))

export const EntitiesRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--entities']}>
    <Route index element={<Index />} />
    <Route path='organisation/*' element={<OrganisationRouter />} />
    <Route path='person/*' element={<PersonRouter />} />
    <Route path='user/*' element={<PersonRouter />} />
    <Route path='signup-request/*' element={<SignupRequestRouter />} />
    <Route path='user-invitation/*' element={<UserInvitationRouter />} />
  </SubRouter>
))
